import React from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/LanguageContext";
import { getSubscriptionPitchCopy } from "@/lib/subscriptionPitchTranslations";

const tiers = [
  { name: "Free", price: "$0", note: "Start with trusted basics", cta: "Try free tools", href: "/weather", items: ["Basic weather overview", "Public marina discovery", "Learning guides"] },
  { name: "Premium", price: "Best for most skippers", note: "Daily decisions, not more dashboards", cta: "Upgrade to Premium", href: "/premium", featured: true, items: ["Personalized skipper briefing", "Route and weather risk alerts", "Boat-specific recommendations"] },
  { name: "Business / Fleet", price: "For operators", note: "Visibility and operations", cta: "Explore fleet tools", href: "/fleet-operations", items: ["Fleet workflows", "Marina visibility", "Team-ready planning"] },
];

export default function SimpleSubscriptionTiers() {
  const { lang: routeLang } = useParams();
  const { language } = useLanguage();
  const lang = routeLang || language || "en";
  const prefix = lang === "en" ? "/en" : `/${lang}`;
  const localizedTiers = tiers.map((tier, index) => ({ ...tier, ...getSubscriptionPitchCopy(lang).tiers[index] }));

  return (
    <section className="grid gap-4 md:grid-cols-3">
      {localizedTiers.map((tier) => <article key={tier.name} className={`rounded-[2rem] border p-6 shadow-xl ${tier.featured ? "border-primary bg-ocean text-white" : "border-border bg-card"}`}>
        {tier.featured && <p className="mb-3 inline-flex rounded-full bg-white/15 px-3 py-1 text-xs font-black uppercase tracking-wide text-cyan-100">{tier.featured}</p>}
        <h3 className="font-heading text-2xl font-black">{tier.name}</h3>
        <p className={`mt-2 text-lg font-black ${tier.featured ? "text-white" : "text-primary"}`}>{tier.price}</p>
        <p className={`mt-1 text-sm ${tier.featured ? "text-cyan-50/80" : "text-muted-foreground"}`}>{tier.note}</p>
        <div className="mt-5 space-y-3">{tier.items.map((item) => <p key={item} className="flex items-center gap-2 text-sm font-bold"><CheckCircle2 className="h-4 w-4 text-primary" />{item}</p>)}</div>
        <Button asChild className="mt-6 w-full" variant={tier.featured ? "secondary" : "default"}><Link to={`${prefix}${tier.href}`}>{tier.cta}</Link></Button>
      </article>)}
    </section>
  );
}